import React from 'react';

const Home_entree_metiers = () => {
    return (
        <section className="container_icons">
            <div className="left_icons">
                <div className="metier_gauche">
                    <div className="container_txt">
                        <div className="icon"><i className="uil uil-bath"></i></div>
                        <p>Salle de bain</p>
                    </div>
                </div>
                <div className="metier_gauche">
                    <div className="container_txt">
                        <div className="icon"><i className="uil uil-snowflake"></i></div>
                        <p>Climatisation</p>
                    </div>
                </div>
                <div className="metier_gauche">
                    <div className="container_txt">
                        <div className="icon"><i className="uil uil-raindrops"></i></div>
                        <p>Traitement de l'eau</p>
                    </div>
                </div>
            </div>
            <div className="right_icons">
                <div className="metier_gauche">
                    <div className="container_txt">
                        <div className="icon"><i className="uil uil-bolt"></i></div>
                        <p>Électricité</p>
                    </div>
                </div>
                <div className="metier_gauche">
                    <div className="container_txt">
                        <div className="icon"><i className="uil uil-fire"></i></div>
                        <p>Chauffage</p>
                    </div>
                </div>
                <div className="metier_gauche">
                    <div className="container_txt">
                        <div className="icon"><i className="uil uil-exclamation-triangle"></i></div>
                        <p>Urgence/Dépannage</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Home_entree_metiers;